import { LitElement, html } from 'lit';
import { t } from '../i18n';
import { mergeDiscoveredIds, type CalendarMode, type ProviderDiscovery } from '../connection-sync-rules-logic';
import { defineZenComponent } from './register';

export class ZenGcalSyncFilterEditor extends LitElement {
  static properties = {
    modes: { attribute: false },
    discovery: { attribute: false },
    disabled: { type: Boolean },
    saving: { type: Boolean },
    dirty: { type: Boolean },
  };

  declare modes: Record<string, { mode: CalendarMode }>;
  declare discovery: ProviderDiscovery;
  declare disabled: boolean;
  declare saving: boolean;
  declare dirty: boolean;

  constructor() {
    super();
    this.modes = {};
    this.discovery = { status: 'idle', items: [] };
    this.disabled = false;
    this.saving = false;
    this.dirty = false;
  }

  createRenderRoot() { return this; }

  private changeMode(id: string, mode: CalendarMode) {
    this.dispatchEvent(new CustomEvent('filter-change', {
      detail: { ...this.modes, [id]: { mode } }, bubbles: true, composed: true,
    }));
  }

  render() {
    const readOnly = this.disabled || this.saving || this.discovery.status !== 'available';
    const calendars = mergeDiscoveredIds(this.discovery.items, Object.keys(this.modes));
    return html`
      ${this.discovery.status === 'loading' ? html`<p class="sync-filter-note">${t('connectionFilterLoading')}</p>` : ''}
      ${this.discovery.status === 'degraded' ? html`
        <p class="sync-filter-degraded"><span class="mi mi-sm" aria-hidden="true">info</span>${t('connectionFilterDegraded')}</p>
      ` : ''}
      <div class="sync-filter-calendar-list">
        ${calendars.map((calendar) => html`
          <label>
            <span><strong>${calendar.name}</strong><small>${calendar.id}</small></span>
            <select .value=${this.modes[calendar.id]?.mode ?? 'off'} ?disabled=${readOnly}
              @change=${(event: Event) => this.changeMode(calendar.id, (event.target as HTMLSelectElement).value as CalendarMode)}>
              <option value="off">${t('calendarModeOff')}</option>
              <option value="events_only">${t('calendarModeEventsOnly')}</option>
              <option value="goals">${t('calendarModeGoals')}</option>
            </select>
          </label>
        `)}
      </div>
      <button type="button" class="btn btn-primary btn-sm" ?disabled=${readOnly || !this.dirty}
        @click=${() => this.dispatchEvent(new CustomEvent('filter-save', { detail: this.modes, bubbles: true, composed: true }))}>
        <span class="mi mi-xs" aria-hidden="true">save</span>${t('connectionFilterSave')}
      </button>
    `;
  }
}

defineZenComponent('zen-gcal-sync-filter-editor', ZenGcalSyncFilterEditor);
